import { useEffect, useRef, useState } from "react";
import unityBinaryData from "../unityBinaryData.json";
import log from "../util/logger";

type Props = {
    canvas: HTMLCanvasElement;
    unityBuildRoot: string;
    renderCount: number;
    onComplete?: (instance: UnityInstance) => void;
};

export const useUnity = ({ canvas, unityBuildRoot, renderCount, onComplete }: Props) => {
    const [retryCount, setRetryCount] = useState<number>(0);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const instanceRef = useRef<UnityInstance>();

    useEffect(() => {
        if (!window.createUnityInstance) {
            const t = window.setTimeout(() => {
                setRetryCount((c) => c + 1);
            }, 100);
            return () => {
                window.clearTimeout(t);
            };
        }
        handleStart();
        return () => {
            const { current } = instanceRef;
            if (current) {
                current.Quit();
            }
        };
    }, [retryCount, renderCount]);

    const onProgress = (n: number) => {
        log("createUnityInstance onProgress: ", n);
    };

    const handleStart = () => {
        const { current } = containerRef;
        if (!current) {
            return;
        }

        current.innerHTML = "";
        canvas.setAttribute("id", `unity-canvas`);
        current.appendChild(canvas);

        window
            .createUnityInstance(
                canvas,
                {
                    companyName: "DefaultCompany",
                    productName: "telexistence_test_avatar",
                    productVersion: "0.1",
                    dataUrl: `${unityBuildRoot}/${unityBinaryData.dataUrl}`,
                    frameworkUrl: `${unityBuildRoot}/${unityBinaryData.frameworkUrl}`,
                    codeUrl: `${unityBuildRoot}/${unityBinaryData.codeUrl}`,
                    streamingAssetsUrl: "StreamingAssets",
                },
                onProgress
            )
            .then((instance) => {
                instanceRef.current = instance;
                onComplete?.(instance);
            })
            .catch((msg) => {
                console.error(msg);
            });
    };

    return {
        instanceRef,
        containerRef,
    };
};
